import * as React from "react"
import {useEffect} from "react"
import {AnalyticsLayoutWrapperPage} from "@ui-seeker/app";
import {pageTitle, pageSubtitle} from "@app/@signals";
import AppImageModal from "./ImageModal";


export default function PageWrapper({ title, subtitle, breadcrumb, children, ...props }) {
    // Feed the vendored shell header (MaximalLayout) instead of rendering a
    // second title inside the legacy @ui-seeker wrapper. `title`/`subtitle`/
    // `breadcrumb` are intentionally NOT forwarded so the old wrapper draws no
    // title block — the single source of truth is the shell header.
    useEffect(() => {
        pageTitle.value = title || ''
        pageSubtitle.value = subtitle || ''
        return () => {
            pageTitle.value = ''
            pageSubtitle.value = ''
        }
    }, [title, subtitle])

    return <>
        <AnalyticsLayoutWrapperPage {...props}>
            {children}
        </AnalyticsLayoutWrapperPage>

        <AppImageModal />
    </>
}
